<template>
    <div>
        <div class="row">
            <div class="card pozo col ml-1" v-for="(p,idx) in pocitos" :key="p.id">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <h1 class="texto-blanco">{{p.nombre}}

                            <span class="badge badge-primary">{{p.ultima_fecha_descarga == null?'DETENIDO':'DESCARGANDO A PROCESO'}}</span>
                        </h1>
                    </div>
                    <div class="col">
                        <h3 class="texto-naranjo text-right">
                            Tiempo Descarga: {{p.tiempo_descarga}}
                        </h3>
                    </div>
                </div>
                
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <div class="flexContainer">
                            <input class="form-control inputField" type="number" placeholder="Ingresar Saldo" v-model="p.saldo_pozo">
                            <button @click="registrar_saldo(p,idx)" class="btn btn-danger" type="submit" :disabled="!p.saldo_pozo">Detener Descarga</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <button v-if="p.ultima_fecha_descarga == null" class="btn btn-success" @click="comenzar_descarga(p,idx)"><i class="fas fa-play"></i> Comenzar Descarga</button>
            </div>
        </div>
        </div>
        <!-- <pre>{{pocitos}}</pre> -->
    </div>
    
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        pozos:[]
    }),
    mounted(){
        this.cargar_pozos();
    },
    methods:{
        async cargar_pozos(){
            await this.axios.get(`${this.api}/pozos`,this.cabeceras_json).then((res)=>{
                this.pozos = res.data.data.data;
                this.pozos.forEach((p,idx) => {
                    this.$set(this.pozos[idx],'tiempo_descarga','00:00:00');
                });
            }).catch((e)=>{
                //console.log(e);
            });
        },
        async comenzar_descarga(p,idx){
            await this.axios.post(`${this.api}/pozos/${p.id}/comenzar_descarga`,{},this.cabeceras_json).then((res)=>{
                //console.log(res.data.data);
                this.$set(this.pozos[idx],'ultima_fecha_descarga',res.data.data.ultima_fecha_descarga);
            }).catch((e)=>{
                //console.log(e);
            })
        },
        async registrar_saldo(p,idx){
            let body = {
                saldo_pozo:p.saldo_pozo
            }
            await this.axios.post(`${this.api}/pozos/${p.id}/registrar_saldo`,body,this.cabeceras_json).then((res)=>{
                //console.log(res.data.data);
                this.$set(this.pozos[idx],'ultima_fecha_descarga',null);
                this.$set(this.pozos[idx],'tiempo_descarga','00:00:00');
            }).catch((e)=>{
                //console.log(e);
            })
        }
    },
    computed:{
        ...mapState(['api','cabeceras_json']),
        pocitos(){
            this.pozos.forEach(p => {
                if(p.ultima_fecha_descarga != null){
                    var limite = this.$moment(p.ultima_fecha_descarga);
                    setInterval(function() { 
                        var now = new Date().getTime(); 
                        /**indica el tiempo restante con respecto a la fecha actual */
                        //var t = limite - now; 
                        /**now - limite entrega el tiempo transcurrido desde fecha de expiracion */
                        var t = now - limite; 

                        var days = Math.floor(t / (1000 * 60 * 60 * 24)); 
                        var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60)); 
                        var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)); 
                        var seconds = Math.floor((t % (1000 * 60)) / 1000);
                        hours = hours < 10? `0${hours}`:hours;
                        minutes = minutes < 10? `0${minutes}`:minutes;
                        seconds = seconds < 10? `0${seconds}`:seconds;
                        // guia.restante.TIEMPO_RESTANTE = `${hours}:${minutes}:${seconds}`;
                        days = days > 0 ? `${days} DIAS, ` : '';
                        p.tiempo_descarga = `${days}${hours}:${minutes}:${seconds}`;
                        
                    }, 1000);
                }
                
            });
            return this.pozos;
        },
    }
}
</script>
<style>
.pozo{
    background-color: #5f5f79;
    color: #fff;
}
.texto-naranjo{
 color: #e9ae0a;
 font-size: 25px;
}
.texto-blanco{
 color: #fff;
}

.flexContainer {
    display: flex;
}

.inputField {
    flex: 1;
}
</style>